/**
 * Shared MRT v3 table configuration applied to all DataTable instances.
 * Spread this into useMaterialReactTable() before caller-specific overrides.
 *
 * Usage:
 *   import { commonTableProps } from '../../ui/table-v3/props';
 *   const table = useMaterialReactTable({ columns, data, ...commonTableProps, ...callerOverrides });
 */
export const commonTableProps = {
  localization: {
    actions: "",
    rowsPerPage: "Rows/page",
  },
  layoutMode: "grid",
  enableColumnResizing: true,
  columnResizeMode: "onChange",
  enableColumnFilterModes: true,
  enableColumnOrdering: true,
  enableGrouping: true,
  enableColumnPinning: true,
  enableFullScreenToggle: false,
  enableStickyHeader: true,
  enableExpandAll: false,
  enableDensityToggle: false,
  defaultColumn: {
    maxSize: 1400,
    minSize: 80,
    size: 110,
    muiTableBodyCellProps: {
      sx: {
        height: "41px",
        textWrap: "wrap",
        overflow: "scroll",
        padding: "5px",
        "::-webkit-scrollbar": { height: 0, width: 0 },
        "::-webkit-scrollbar-thumb": { height: 0, width: 0 },
        "::-webkit-scrollbar-track": { height: 0, width: 0 },
          display: "flex !important",
          justifyContent: "flex-start !important",
          alignItems: "center !important",
          marginTop: "0px",
      },
    },
  },
  displayColumnDefOptions: {
    "mrt-row-expand": {
      grow: false,
      header: "",
      enableHiding: true,
      size: 20,
      minSize: 20,
      maxSize: 20,
    },
    "mrt-row-numbers": { size: 20, maxSize: 20, minSize: 20, enableHiding: true },
  },
  initialState: { density: "compact" },
  muiTableHeadCellProps: {
    sx: {
      // backgroundColor: "var(--table-header-bg-color)",
      color: "var(--table-header-text-color)",
      "& .Mui-TableHeadCell-Content": { justifyContent: "flex-start", gap: "4px" },
      "& .Mui-TableHeadCell-Content-Actions": { marginLeft: "auto" },
    },
  },
  muiTableBodyRowProps: {
    sx: { backgroundColor: "var(--table-row-bg-color)" },
  },
  muiTableBodyCellProps: {
    sx: { color: "var(--table-cell-text-color)" },
  },
  muiDetailPanelProps: {
    sx: {
      "& .MuiCollapse-root, & .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner": {
        width: "100%",
      },
    },
  },
  enableBottomToolbar: false,
  positionPagination: "top",
  muiTablePaperProps: {
    sx: { background: "transparent", backgroundImage: "none", boxShadow: "none", paddingRight: "10px" },
  },
  muiTopToolbarProps: {
    sx: {
      "& .MuiTablePagination-root": {
        display: "flex !important",
        flex: "111 !important",
        justifyContent: "center !important",
        minWidth: "calc(100% - 20px) !important",
        margin: "5px !important",
      },
      border: "unset",
      background: "transparent",
      backgroundImage: "none",
      overflow: "hidden",
      "& .MuiTablePagination-root .MuiInputLabel-root": { fontSize: "14px" },
      "& .MuiTablePagination-root .MuiInputBase-input": { fontSize: "14px" },
      "& .MuiTablePagination-spacer": { display: "none" },
    },
  },
  muiBottomToolbarProps: {
    sx: { background: "transparent", backgroundImage: "none", boxShadow: "none" },
  },
  muiTableContainerProps: {
    sx: {
      margin: 0,
      marginLeft: "10px",
      marginRight: "10px",
      borderRadius: "8px 8px 0 0",
      flex: 1,
      overflow: "auto",
      overflowX:"hidden !important",
      scrollbarWidth:"thin !important",
      scrollbarColor:"var(--assess-scrollbar-thumb) transparent !important",
      boxShadow: "unset",
      height: "calc(100vh - 140px)",
      minHeight: "calc(100vh - 100px)",
      maxHeight: "calc(100vh - 100px)",
      width: "calc(100% - 20px)",
      
    },
  },
};
